/* PavCon, LLC Proprietary.All rights reserved 2022 */
export enum AuthLevel {
  Authorized = 1,
  Unauthorized = 0,
  UndefinedAuth = -1,
}
